export default function (pageNumber, summaries, totalSummariesCount) {
  return {
    type: 'LOAD SUMMARIES',
    pageNumber: pageNumber,
    summaries: summaries,
    totalSummariesCount: totalSummariesCount
  };
}
